__turbopack_context__.v({
  "actionButton": "SHe0lq_actionButton",
  "actions": "SHe0lq_actions",
  "button": "SHe0lq_button",
  "buttonText": "SHe0lq_buttonText",
  "container": "SHe0lq_container",
  "fileInput": "SHe0lq_fileInput",
  "header": "SHe0lq_header",
  "importButton": "SHe0lq_importButton",
  "isVisible": "SHe0lq_isVisible",
  "list": "SHe0lq_list",
  "name": "SHe0lq_name",
  "title": "SHe0lq_title",
});
